var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item-action',{staticClass:"mr-1 ml-0"},[_c('v-btn',{class:{ 'primary--text': _vm.$store.state.settings.gps },attrs:{"icon":"","outlined":"","title":"GPS"},on:{"click":_vm.fromGPS}},[_c('v-icon',[_vm._v("mdi-crosshairs-gps")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }